import { saveExcel } from '@progress/kendo-vue-excel-export';

export const downloadCSV = (data: object[], fileName: string = 'download.csv') => {
  const headings = Object.keys(data[0]);
  const rows = [
    headings.join(","),
    data.map(r => Object.values(r).map(r => `"${r}"`).join(",")).join("\n"),
  ].join("\n")

  const csvContent = `data:text/csv;charset=utf-8,${rows}`;
  const a = document.createElement('a');
  a.href = encodeURI(csvContent);
  a.download = fileName;
  a.target = '_blank';
  a.classList.add('tw-hidden');
  a.click();
  a.remove();
}

export const downloadExcel = (data: object[], headings: object[], fileName: string = 'download') => {

  saveExcel({
    data: data,
    fileName: fileName,
    columns: headings
  });
}